function initScrollAnimations() {
  const animatedElements = Array.from(document.querySelectorAll('*')).filter(function (element) {
    return getComputedStyle(element).getPropertyValue('--scroll-animation').trim() === 'fade-up';
  });

  if (!animatedElements.length) return;

  const observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('scroll-animation-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.15
  });

  animatedElements.forEach(function (element) {
    element.classList.add('scroll-animation-ready');
    observer.observe(element);
  });
}

document.addEventListener('DOMContentLoaded', initScrollAnimations);
document.addEventListener('shopify:section:load', initScrollAnimations);